export default {
  methods: {
    getImage(path) {
      if (path.includes('https://')) {
        return path;
      }

      const baseUrl = global.BASE_URL || process.env.VUE_APP_BASE_URL;
      if (baseUrl) {
        return `${baseUrl.replace('local.', '')}${path}`;
      }
      return null;
    },
  },
};
